import {
  HasuraDataTableColumnDef,
  DataTableEx,
  DataTableExProps,
  DataTableExRef,
  FormInput,
  AutocompleteInput,
} from '@kirz/mui-admin';
import React, {
  forwardRef,
  Ref,
  useImperativeHandle,
  useMemo,
  useRef,
} from 'react';

export const DirectoriesTable = forwardRef(
  (
    props: Partial<DataTableExProps> & {
      id: string;
      filterColumns?: (
        columns: HasuraDataTableColumnDef[],
      ) => HasuraDataTableColumnDef[];
    },
    ref: Ref<DataTableExRef>,
  ) => {
    const { filterColumns, ...rest } = props;
    const tableRef = useRef<DataTableExRef>(null);

    useImperativeHandle(ref, () => tableRef.current!, []);

    const columns = useMemo<HasuraDataTableColumnDef[]>(
      () =>
        (filterColumns || ((x: HasuraDataTableColumnDef[]) => x))([
          {
            field: 'name',
            headerName: 'Naam',
            flex: 1,
          },
          {
            field: 'formattedName',
            headerName: 'Naam Menu',
            flex: 1,
          },
          {
            field: 'emailAccountSuffix',
            headerName: 'E-mail achtervoegsel',
            flex: 1,
          },
          { field: 'createdAt', headerName: 'Aangemaakt op', type: 'date' },
        ]),
      [filterColumns],
    );

    return (
      <DataTableEx
        {...rest}
        ref={tableRef}
        source="directory"
        columns={columns}
        persistStateMode="query"
        sortBy={rest.sortBy ?? { field: 'createdAt', sort: 'desc' }}
        editable={{
          onEdit(row) {
            tableRef.current?.openFormDialog(row);
          },
        }}
        formTitle={(isNew) => (isNew ? 'Map toevoegen' : 'Map wijzigen')}
        formDialogProps={{
          ...rest.formDialogProps,
          maxWidth: 'sm',
        }}
      >
        <FormInput name="name" label="Naam" md={12} required />
        <FormInput name="formattedName" label="Naam menu" md={12} />
        <FormInput
          name="emailAccountSuffix"
          label="E-mail achtervoegsel"
          md={12}
        />
      </DataTableEx>
    );
  },
);
